import React, { Fragment } from 'react'
import { Intro, Voiceover, SwipeCards } from 'cvs-core'
import voAudio from '../../assets/vo/Learn-Responding-to-pressure-01.mp3'
import img1 from '../../assets/images/U1-T1-11a.svg'
import img2 from '../../assets/images/U1-T1-11b.svg'
import img3 from '../../assets/images/U1-T1-11c.svg'
import img4 from '../../assets/images/U1-T1-11d.svg'
import img5 from '../../assets/images/U1-T1-11e.svg'

const vo = {
  sources: [
    {
      src: voAudio,
    },
  ],
  transcript:
    'Ben chooses not to begin vaping or using e-cigarettes. Continue to explore information about how he can communicate his choice to his friends.',
}

const data = [
  {
    image: img2,
    imageText: 'Direct Refusal',
    title: 'Direct Refusal',
    body:
      'A direct refusal is saying “no” or “no, thank you.” Ben can tell his friends, “No, I am not going to use e-cigarettes.”',
  },
  {
    image: img3,
    imageText: 'Exit Strategies',
    title: 'Exit Strategies',
    body:
      'An exit strategy is a plan to get out of or away from a potentially risky situation. Ben could say, “I have to get to class,” or, “let’s go see what Alicia is up to,” and leave the bathroom.',
  },
  {
    image: img4,
    imageText: 'Provide Information',
    title: 'Provide Information',
    body:
      'Ben can tell his friends the risks he has learned about vaping. He can say something like, “I want to be in the best shape for basketball tryouts,” or, “No thanks. I don’t want to get addicted to nicotine.”',
  },
  {
    image: img5,
    imageText: 'Human Resources',
    title: 'Human Resources',
    body: (
      <span>
        Ben can rely on <em>human resources</em> like parents, teachers,
        coaches, etc. Ben can go to a trusted adult to get help handling the
        situation with his friends.
      </span>
    ),
  },
]

export default {
  title: 'Responding to Pressure',
  path: '/learn/responding-to-pressure',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="Responding to Pressure"
        lead="Ben chooses not to begin vaping/using e-cigarettes. Swipe through the cards to display information about how he can communicate his choice to his friends."
        direction="Swipe each card to advance."
        img={img1}
      />
      <SwipeCards data={data} />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Learn/RespondingToPressure.js